import { Select, Text, HStack, VStack } from '@genial/components';
import { Box } from 'native-base';
import React, { useEffect, useMemo, useState } from 'react';

import {
  getMonthYearFromReferenceDate,
  getProfitabilityYearRange,
  parseMonthYearToReferenceDate,
} from '../../../../../store/reportGenerator/referenceDateFromMonthYear';
import {
  buildYearOptions,
  monthsOptions,
} from '../../../../CustomerDetail/components/Summary/components/ProfitabilityChart/constants';

import {
  RequestModalFieldShell,
  requestModalSelectTriggerProps,
  requestModalSelectTriggerTextProps,
} from './requestModalFieldStyles';

type ProfitabilityPeriodFieldsProps = {
  referenceDate?: Date;
  updateReferenceDate: (value: Date | undefined) => void;
};

export const ProfitabilityPeriodFields: React.FC<ProfitabilityPeriodFieldsProps> = ({
  referenceDate,
  updateReferenceDate,
}) => {
  const initial = getMonthYearFromReferenceDate(referenceDate);
  const [month, setMonth] = useState(initial.month);
  const [year, setYear] = useState(initial.year);

  const yearsOptions = useMemo(() => {
    const { startYear, endYear } = getProfitabilityYearRange();
    return buildYearOptions(startYear, endYear);
  }, []);

  useEffect(() => {
    const next = getMonthYearFromReferenceDate(referenceDate);
    setMonth(next.month);
    setYear(next.year);
  }, [referenceDate]);

  const syncReferenceDate = (nextMonth: string, nextYear: string) => {
    updateReferenceDate(parseMonthYearToReferenceDate(nextMonth, nextYear));
  };

  const handleMonthChange = (value: string) => {
    setMonth(value);
    syncReferenceDate(value, year);
  };

  const handleYearChange = (value: string) => {
    setYear(value);
    syncReferenceDate(month, value);
  };

  return (
    <VStack space="stack.quarck">
      <Text variant="regular">Período</Text>
      <HStack w="full" space="stack.nano" alignItems="flex-end">
        <Box flex={1}>
          <RequestModalFieldShell>
            <Select
              testID="report-generator-profitability-month-select"
              triggerProps={requestModalSelectTriggerProps}
              triggerTextProps={requestModalSelectTriggerTextProps}
              placeholder="Mês"
              options={monthsOptions}
              selectedValue={month}
              onValueChange={handleMonthChange}
              maxOptionPerRender={8}
              maxOptionsContentHeight="80vh"
            />
          </RequestModalFieldShell>
        </Box>
        <Box flex={1}>
          <RequestModalFieldShell>
            <Select
              testID="report-generator-profitability-year-select"
              triggerProps={requestModalSelectTriggerProps}
              triggerTextProps={requestModalSelectTriggerTextProps}
              placeholder="Ano"
              options={yearsOptions}
              selectedValue={year}
              onValueChange={handleYearChange}
              maxOptionPerRender={8}
              maxOptionsContentHeight="80vh"
            />
          </RequestModalFieldShell>
        </Box>
      </HStack>
    </VStack>
  );
};
